import confetti from "canvas-confetti"
import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Button, Card, CardBody, Container } from "reactstrap"
import { toast } from "react-toastify"

const PVSPaymentSuccess = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const paymentData = location.state || {}

  const {
    razorpay_order_id = "",
    razorpay_payment_id = "",
    subtotal = 0,
    tax = 0,
    total = 0,
  } = paymentData

  useEffect(() => {
    invokeConfetti()
  }, [])

  const invokeConfetti = () => {
    const isMobile = window.innerWidth < 768

    const fire = (particleRatio, opts) => {
      confetti({
        particleCount: Math.floor(210 * particleRatio),
        spread: 55,
        startVelocity: isMobile ? 30 : 45,
        ticks: isMobile ? 120 : 200,
        gravity: 0.9,
        scalar: isMobile ? 0.7 : 1,
        colors: ["#880356", "#fee6f7", "#f472b6", "#c084fc"],
        ...opts,
      })
    }

    fire(0.25, { origin: { x: 0, y: 0.6 }, angle: 60 })
    fire(0.2, { origin: { x: 0, y: 0.6 }, angle: 60, spread: 180 })
    fire(0.25, { origin: { x: 1, y: 0.6 }, angle: 120 })
    fire(0.2, { origin: { x: 1, y: 0.6 }, angle: 120, spread: 180 })
    fire(0.2, {
      origin: { x: 0.5, y: 0.5 },
      angle: 90,
      spread: 120,
      startVelocity: 40,
    })
  }

  const copyToClipboard = text => {
    if (!text) return
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        toast.success("Copied to clipboard!")
      })
    } else {
      const el = document.createElement("textarea")
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand("copy")
      document.body.removeChild(el)
      toast.success("Copied to clipboard!")
    }
  }

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="newaward-maincontainer p-4">
          <div className="congrats-box content-boxnew text-center">
            <div className="success-icon">🎉</div>
            <h1 className="h1">Payment Successful!</h1>
            <p className="text-muted mb-4">
              Thank you for completing the application process! Our team will
              verify your details and reach out to you in case of any concerns.
              Please make sure that you check the registered WhatsApp number and
              email ID for further communication.
            </p>

            <div
              className="w-100 text-start mb-4"
              style={{ maxWidth: "480px", margin: "0 auto" }}
            >
              <div className="border rounded p-3 bg-light">
                <h6 className="fw-bold mb-3 text-dark">Payment Summary</h6>

                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted">Order ID</span>
                  <span className="d-flex align-items-center gap-2">
                    <span
                      className="fw-semibold text-dark"
                      style={{ wordBreak: "break-all", textAlign: "right" }}
                    >
                      {razorpay_order_id}
                    </span>
                    <button
                      title="Copy Order ID"
                      onClick={() => copyToClipboard(razorpay_order_id)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "2px 4px",
                        flexShrink: 0,
                      }}
                    >
                      <i className="dripicons-copy text-primary" />
                    </button>
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="text-muted">Razorpay Payment ID</span>
                  <span className="d-flex align-items-center gap-2">
                    <span
                      className="fw-semibold text-dark"
                      style={{ wordBreak: "break-all", textAlign: "right" }}
                    >
                      {razorpay_payment_id}
                    </span>
                    <button
                      title="Copy Payment ID"
                      onClick={() => copyToClipboard(razorpay_payment_id)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "2px 4px",
                        flexShrink: 0,
                      }}
                    >
                      <i className="dripicons-copy text-primary" />
                    </button>
                  </span>
                </div>

                <div className="border-top pt-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Subtotal</span>
                    <span>₹ {Number(subtotal).toLocaleString("en-IN")}.00</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">GST (18%)</span>
                    <span>₹ {Number(tax).toLocaleString("en-IN")}.00</span>
                  </div>
                  <div className="d-flex justify-content-between fw-bold pt-2 border-top">
                    <span>Total Paid</span>
                    <span className="text-success">
                      ₹ {Number(total).toLocaleString("en-IN")}.00
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button
                className="primary-button"
                onClick={() => navigate("/home")}
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PVSPaymentSuccess
